const utilities = require('../modules/utilities'),
    Tracker = require('../../../global/js/modules/google-analytics')
;

let $map_toggles, $feature_wrapper, $itinerary_cont, $feature_items,
    $feature_map, $map_overlay, $map_close_button;

let tabsLocked = false;

let closeCallback = null;

function maybeLockTabs() {
    if (tabsLocked) {
        return;
    }
    tabsLocked = true;
    utilities.containTabSwitching($feature_map);
}

function unlockTabs() {
    if (tabsLocked) {
        tabsLocked = false;
        utilities.unlockTabSwitching();
    }
}

function openMap() {
    // Setup the container and styling for the maps, ie the search overlay
    $feature_wrapper.classList.add('map-open');
    $itinerary_cont.classList.add('map-open');
    document.querySelector('body').classList.add('map-open');

    if (utilities.isProbablyMobile()) {
        maybeLockTabs();
    }

    Tracker.track(
        'Google Map',
        'Change Visibility',
        'Show'
    );

}

function closeMap() {
    $feature_wrapper.classList.remove('map-open');
    $itinerary_cont.classList.remove('map-open');
    document.querySelector('body').classList.remove('map-open');

    $feature_wrapper.classList.add('map-closing');
    setTimeout(function () {
        $feature_wrapper.classList.remove('map-closing');
    }, 400);

    unlockTabs();

    if (closeCallback) {
        closeCallback();
    }

    Tracker.track(
        'Google Map',
        'Change Visibility',
        'Hide'
    );
}

function toggleMap() {
    // if it's closed, open it
    if (!$feature_wrapper.classList.contains('map-open')) {
        openMap();
    }
    // if it's open, close it
    else {
        closeMap();
    }
}

function setCloseCallback(callback) {
    if (typeof callback !== 'function') {
        callback = null;
    }

    closeCallback = callback;
}

//__________ Show / Hide Google Maps Embed __________

document.addEventListener("DOMContentLoaded", function() {

    $map_toggles = document.querySelectorAll('.mapButton');
    $feature_wrapper = document.querySelector('#featureWrap');
    $itinerary_cont = document.querySelector('.itineraryCont');

    $feature_items = document.querySelector('#featureItems');
    $feature_map = document.querySelector('#featureMap');

    if (!$feature_map) return;

    $map_overlay = $feature_map.querySelector('.featureMap__overlay');
    $map_close_button = $feature_map.querySelector('.featureMap__closeButton');

    document.addEventListener('hertz.viewport.change', (event) => {
        if (typeof $feature_wrapper !== 'undefined' && !$feature_wrapper.classList.contains('map-open')) {
            return;
        }
        if (utilities.isProbablyMobile()) {
            maybeLockTabs();
        }
        else {
            unlockTabs();
        }
    });

    // // Add click listeners to all the map toggles
    // for (let $map_toggle of $map_toggles) {
    //     $map_toggle.addEventListener('click', toggleMap);
    // }

    // Event listener for map overlay
    if (typeof $map_overlay !== 'undefined') {
        $map_overlay.addEventListener('click', closeMap);
    }

    // Event listener on close button
    if (typeof $map_close_button !== 'undefined') {
        $map_close_button.addEventListener('click', closeMap);
    }


});

//__________ Module Exports __________

module.exports = {
    setCloseCallback,
    toggleMap: toggleMap,
    openMap: openMap,
    closeMap: closeMap,
};
